import { useState, useRef } from 'react';
import './Protocolos.css';
import { protocolosData } from '../../constants/protocolos';
import { WHATSAPP_NUMBER } from '../../constants/profissionais';

function Protocolos() {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [modalAberto, setModalAberto] = useState(null);
  const carrosselRef = useRef(null);

  const getWhatsAppLink = (mensagem) => {
    const mensagemCodificada = encodeURIComponent(mensagem);
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${mensagemCodificada}`;
  };

  const abrirModal = (protocoloId) => {
    setModalAberto(protocoloId);
    document.body.style.overflow = 'hidden'; // Previne scroll do body quando modal está aberto
  };

  const fecharModal = () => {
    setModalAberto(null);
    document.body.style.overflow = 'unset';
  };

  const scrollCarrossel = (direction) => {
    if (carrosselRef.current) {
      const scrollAmount = 400;
      const newScrollPosition = carrosselRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
      carrosselRef.current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="protocolos-section" id="protocolos">
      <div className="protocolos-container">
        <div className="carrossel-wrapper">
          <button
            className="carrossel-btn carrossel-btn-left"
            onClick={() => scrollCarrossel('left')}
            aria-label="Rolar para esquerda"
          >
            ‹
          </button>

          <div className="protocolos-carrossel" ref={carrosselRef}>
            {protocolosData.map((protocolo) => (
              <div
                key={protocolo.id}
                className={`protocolo-card ${hoveredCard === protocolo.id ? 'hovered' : ''}`}
                onMouseEnter={() => setHoveredCard(protocolo.id)}
                onMouseLeave={() => setHoveredCard(null)}
                onClick={() => abrirModal(protocolo.id)}
              >
                <div className="protocolo-card-inner">
                  <img
                    src={protocolo.imagem}
                    alt={protocolo.nome}
                    className="protocolo-imagem"
                  />
                  <div className="protocolo-overlay">
                    <span className="protocolo-cta">Saiba mais →</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            className="carrossel-btn carrossel-btn-right"
            onClick={() => scrollCarrossel('right')}
            aria-label="Rolar para direita"
          >
            ›
          </button>
        </div>
      </div>

      {/* Modal */}
      {modalAberto && (
        <div className="protocolo-modal-overlay" onClick={fecharModal}>
          <div className="protocolo-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="protocolo-modal-fechar" onClick={fecharModal}>
              ✕
            </button>

            {protocolosData
              .filter((protocolo) => protocolo.id === modalAberto)
              .map((protocolo) => (
                <div key={protocolo.id} className="protocolo-modal-conteudo">
                  <div className="protocolo-modal-imagem-container">
                    <img
                      src={protocolo.imagem}
                      alt={protocolo.nome}
                      className="protocolo-modal-imagem"
                    />
                  </div>

                  <div className="protocolo-modal-body">
                    <h2 className="protocolo-modal-titulo">{protocolo.nome}</h2>

                    <div className="protocolo-modal-texto">
                      {protocolo.descricao.map((paragrafo, index) => (
                        <p key={index}>{paragrafo}</p>
                      ))}
                    </div>

                    <a
                      href={getWhatsAppLink(protocolo.mensagem)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="protocolo-modal-btn-whatsapp"
                    >
                      Saiba +
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default Protocolos;
